import React, { Component } from "react";

import $ from "jquery";
import foodSurveyVector from "../../MyFiles/Vector/foodSurvey.png";

class Register extends Component {
  state = {
    recipeRequestJson: null,
    errorMessage: "",
    isRegister: true,
    isSelectLunchRecipe: false,
    isSelectDinnerRecipe: false,
    isSurvey: false,
    isReason: false,
    isReasonOther: false,
    isSubmit: true,
    recipeTypeValue: "",
    recipeValue: "",
    surveyValue: "",
    reasonValue: "",
    reasonOtherValue: "",
  };

  componentDidMount() {
    this.getRequest();
  }

  toggleSubmit = () => {
    if (this.state.isSubmit) {
      this.submitForm();
    } else {
      const message = "فرم نظر سنجی را تکمیل و سپس اقدام به ثبت نظر کنید.";
      this.props.toggleErrorMessage(message);
      this.props.toggleError();
    }
  };

  toggledecline = () => {
    this.setState({
      errorMessage: "",
      isRegister: true,
      isSelectLunchRecipe: false,
      isSelectDinnerRecipe: false,
      isSurvey: false,
      isReason: false,
      isReasonOther: false,
      isSubmit: false,
      recipeTypeValue: "",
      recipeValue: "",
      surveyValue: "",
      reasonValue: "",
      reasonOtherValue: "",
    });
  };

  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
      var SendRequest = false;
      var selectReason = 0;
      if (this.state.surveyValue === "ناراضی") {
        var cusid_ele = document.getElementsByClassName("dvCandidate");
        if (cusid_ele.length !== 0) {
          for (var i = 0; i < cusid_ele.length; ++i) {
            var item = cusid_ele[i];
            if (item.classList.contains("active") === true)
              selectReason = selectReason + 1;

            if (i === cusid_ele.length - 1) {
              SendRequest = true;
            }
          }
        }
      } else SendRequest = true;
      if (this.state.surveyValue === "ناراضی" && selectReason === 0) {
        errorMessage = "دلایل نارضایتی خود را انتخاب کنید.";
        this.props.toggleErrorMessage(errorMessage);
        this.props.toggleError();
      } else {
        if (SendRequest === true) {
          var formdata = new FormData();
          formdata.append("token", token);
          formdata.append("type", this.state.recipeTypeValue);
          formdata.append("recipe", this.state.recipeValue);
          formdata.append("survey", this.state.surveyValue);
          formdata.append("reason", this.state.reasonValue);
          formdata.append("other", this.state.reasonOtherValue);

          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-food-survey`,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              if (result !== null) {
                var myObject = JSON.parse(result);
                if (myObject.status === 0) {
                  this.getRequest();
                  errorMessage = "نظر شما با موفقیت در سیستم ثبت شد.";
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                  this.toggledecline();
                } else {
                  errorMessage = myObject.message;
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              }
            })
            .catch((error) => console.log("error", error));
        }
      }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };

  handleRequest = (e) => {
    this.declineRequest(e);
  };

  declineRequest = (e) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      formdata.append("CompetitionRequestTypeRef", 1);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.getRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-recipe`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState({ recipeRequestJson: myObject.data }, function() {
                //console.log(this.state.recipeRequestJson);
              });
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  handleRecipeType = (id) => {
    this.setState({
      recipeValue: "",
      isSelectLunchRecipe: false,
      isSelectDinnerRecipe: false,
      isSurvey: false,
      isReason: false,
    });
    var selectItem = $("#" + id);
    if (selectItem !== null) {
      switch ($(selectItem).val()) {
        case "RecipeMidnight":
          this.setState({
            recipeTypeValue: "RecipeMidnight",
            recipeValue: this.state.recipeRequestJson.RecipeMidnight,
            isSurvey: true,
            isReason: false,
            isReasonOther: false,
            isSelectLunchRecipe: false,
            isSelectDinnerRecipe: false,
          });
          break;
        case "RecipeLunch":
          this.setState({
            recipeTypeValue: "RecipeLunch",
            isSelectLunchRecipe: true,
            isSelectDinnerRecipe: false,
            isSurvey: false,
            isReason: false,
            isReasonOther: false,
          });
          break;
        case "RecipeDinner":
          this.setState({
            recipeTypeValue: "RecipeDinner",
            isSelectDinnerRecipe: true,
            isSelectLunchRecipe: false,
            isSurvey: false,
            isReason: false,
            isReasonOther: false,
          });
          break;
        default:
          break;
      }
    }
  };

  handleRecipe = (id) => {
    this.setState({
      surveyValue: "",
      reasonValue: "",
      reasonOtherValue: "",
      isSurvey: false,
      isSubmit: false,
      isReason: false,
    });
    var selectItem = $("#" + id);
    if (selectItem !== null) {
      if ($(selectItem).val() !== null && $(selectItem).val() !== "")
        this.setState({ isSurvey: true, recipeValue: $(selectItem).val() });
      else this.setState({ isSurvey: false });
    }
  };

  UpdateResponse = (val, reason) => {
    this.setState({ reasonValue: "", reasonOtherValue: "", surveyValue: val });
    reason
      ? this.setState({ isReason: true, isSubmit: false })
      : this.setState({ isReason: false, isSubmit: true });
  };

  selectReason = (id) => {
    var activeReason = 0;
    var valueArray = "";
    if (id > 0) {
      var cusid_ele = document.getElementsByClassName("dvCandidate");
      for (var i = 0; i < cusid_ele.length; ++i) {
        var item = cusid_ele[i];
        var getValue = $(item).attr("data-target");
        if (getValue !== null && getValue.includes(id)) {
          item.classList.toggle("active");
        }
        if (item.classList.contains("active")) {
          activeReason === 0
            ? (valueArray = $(item).attr("data-value"))
            : (valueArray = valueArray + "," + $(item).attr("data-value"));
          activeReason = activeReason + 1;
        }

        if (id === 6 && item.classList.contains("active"))
          this.setState({ isReasonOther: true });
        else if (id === 6 && !item.classList.contains("active"))
          this.setState({ reasonOtherValue: "", isReasonOther: false });

        activeReason > 0
          ? this.setState({ isSubmit: true })
          : this.setState({ isSubmit: false });
      }
      this.setState({ reasonValue: valueArray });
    }
  };

  handleReasonOthers = (e) => {
    const { value } = e.target;
    this.setState({ reasonOtherValue: value });
  };

  render() {
    if (this.state.isRegister === true && this.props.userJson.workplace === 2) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <div className="table-responsive">
              <table className="table table-sm text-center">
                <tbody>
                  <tr>
                    <td colSpan="12" className="text-center">
                      <img
                        alt="ارزیابی غذا"
                        src={foodSurveyVector}
                        rel="noopener noreferrer"
                        className="img-64 rounded-circle"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan="12"
                      className="font-weight-bold bg-light wp-text-xlarge"
                    >
                      ارزیابی عملکرد تهیه و توزیع غذا
                    </td>
                  </tr>
                  {this.state.recipeRequestJson === null ? null : (
                    <>
                      <tr>
                        <td>برنامه غذایی</td>
                        <td>
                          <p className="font-weight-bold text-decoration-none wp-text-xlarge mb-0 text-primary">
                            {this.state.recipeRequestJson.PDate}
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>وعده ناهار</td>
                        <td>
                          <p className="font-weight-bold text-decoration-none mb-0">
                            <span className="ml-2">
                              {this.state.recipeRequestJson.RecipeLunch1}
                            </span>{" "}
                            <span>
                              {this.state.recipeRequestJson.RecipeLunch2}
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>وعده شام</td>
                        <td>
                          <p className="font-weight-bold text-decoration-none mb-0">
                            <span className="ml-2">
                              {this.state.recipeRequestJson.RecipeDinner1}
                            </span>{" "}
                            <span>
                              {this.state.recipeRequestJson.RecipeDinner2}
                            </span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>وعده نیمه‌شبی</td>
                        <td>
                          <p className="font-weight-bold text-decoration-none mb-0">
                            <span className="ml-2">
                              {this.state.recipeRequestJson.RecipeMidnight}
                            </span>
                          </p>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div className="Array p-0 mb-5">
              {this.state.recipeRequestJson === null ? (
                <div className="Array-item">
                  <div className="title text-danger text-center">
                    به دلیل نبود منوی غذایی امکان ثبت نظر وجود ندارد.
                  </div>
                </div>
              ) : (
                <>
                  <div className="col-12 mb-2">
                    <span className="font-weight-bold">
                      انتخاب وعده غذایی
                      <span className="text-danger mr-1">*</span>
                    </span>
                    <select
                      id="RecipeType"
                      name="RecipeType"
                      type="text"
                      className="form-select form-select-lg text-center wp-input-text rounded-0"
                      placeholder="علت درخواست"
                      defaultValue=""
                      onChange={() => this.handleRecipeType("RecipeType")}
                    >
                      <option value="">انتخاب نمایید</option>
                      <option key="1" value="RecipeLunch">
                        وعده ناهار
                      </option>
                      <option key="2" value="RecipeDinner">
                        وعده شام
                      </option>
                      <option key="3" value="RecipeMidnight">
                        وعده نیمه شبی
                      </option>
                    </select>
                  </div>
                  {this.state.isSelectLunchRecipe ? (
                    <div className="col-12 mb-2">
                      <span className="font-weight-bold">
                        انتخاب وعده ناهار
                        <span className="text-danger mr-1">*</span>
                      </span>
                      <select
                        id="RecipeLunchType"
                        name="RecipeLunchType"
                        type="text"
                        className="form-select form-select-lg text-center wp-input-text rounded-0"
                        defaultValue=""
                        onChange={() => this.handleRecipe("RecipeLunchType")}
                      >
                        <option value="">انتخاب نمایید</option>
                        <option
                          value={this.state.recipeRequestJson.RecipeLunch1}
                        >
                          {this.state.recipeRequestJson.RecipeLunch1}
                        </option>
                        <option
                          value={this.state.recipeRequestJson.RecipeLunch2}
                        >
                          {this.state.recipeRequestJson.RecipeLunch2}
                        </option>
                        <option value="سایر">تغییر در برنامه غذایی</option>
                      </select>
                    </div>
                  ) : null}
                  {this.state.isSelectDinnerRecipe ? (
                    <div className="col-12 mb-2">
                      <span className="font-weight-bold">
                        انتخاب وعده شام
                        <span className="text-danger mr-1">*</span>
                      </span>
                      <select
                        id="RecipeDinnerType"
                        name="RecipeDinnerType"
                        type="text"
                        className="form-select form-select-lg text-center wp-input-text rounded-0"
                        defaultValue=""
                        onChange={() => this.handleRecipe("RecipeDinnerType")}
                      >
                        <option value="">انتخاب نمایید</option>
                        <option
                          value={this.state.recipeRequestJson.RecipeDinner1}
                        >
                          {this.state.recipeRequestJson.RecipeDinner1}
                        </option>
                        <option
                          value={this.state.recipeRequestJson.RecipeDinner2}
                        >
                          {this.state.recipeRequestJson.RecipeDinner2}
                        </option>
                        <option value="سایر">تغییر در برنامه غذایی</option>{" "}
                      </select>
                    </div>
                  ) : null}
                  {this.state.isSurvey ? (
                    <>
                      <div className="col-12 mb-1">
                        <span className="font-weight-bold">
                          میزان رضایت مندی خود را اعلام کنید.
                          <span className="text-danger mr-1">*</span>
                        </span>
                      </div>
                      <div className="d-flex">
                        <div className="valid-empty survey-item mb-2 bg-success text-white">
                          <div className="item-query">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="SurveyValue"
                                id="1"
                                value="راضی"
                                onChange={() =>
                                  this.UpdateResponse("راضی", false)
                                }
                              ></input>
                              <label
                                className="form-check-label small"
                                htmlFor="1"
                              >
                                راضی بودم
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="valid-empty survey-item mb-2 mr-2 bg-warning">
                          <div className="item-query">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="SurveyValue"
                                id="2"
                                value="معمولی"
                                onChange={() =>
                                  this.UpdateResponse("معمولی", false)
                                }
                              ></input>
                              <label
                                className="form-check-label small"
                                htmlFor="2"
                              >
                                معمولی بود
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="valid-empty survey-item mb-2 mr-2 bg-danger text-white">
                          <div className="item-query">
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="SurveyValue"
                                id="3"
                                value="ناراضی"
                                onChange={() =>
                                  this.UpdateResponse("ناراضی", true)
                                }
                              ></input>
                              <label
                                className="form-check-label small"
                                htmlFor="3"
                              >
                                ناراضی بودم
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.isReason ? (
                        <div className="col-12">
                          <div className="row">
                            <div className="col-12">
                              <span className="font-weight-bold">
                                علت نارضایتی
                                <small className="text-danger mr-1">
                                  {" "}
                                  (علت را انتخاب کنید تا رنگ سبز آن فعال شود)
                                </small>
                              </span>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={1}
                              data-value="گرم نبودن غذا"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="گرم نبودن غذا"
                                        onClick={() => this.selectReason(1)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">گرم نبودن غذا</div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={2}
                              data-value="مقدار غذا"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="مقدار غذا"
                                        onClick={() => this.selectReason(2)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">مقدار غذا</div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={3}
                              data-value="کیفیت طعم و پخت غذا"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="کیفیت طعم و پخت غذا"
                                        onClick={() => this.selectReason(3)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">
                                        کیفیت طعم و پخت غذا
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={4}
                              data-value="برخورد نامناسب"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="برخورد نامناسب"
                                        onClick={() => this.selectReason(4)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">
                                        برخورد نامناسب
                                      </div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={5}
                              data-value="بهداشت"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="بهداشت"
                                        onClick={() => this.selectReason(5)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">بهداشت</div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="col-4 mb-2 dvCandidate"
                              data-target={6}
                              data-value="سایر"
                            >
                              <div className="w-100 rounded p-1">
                                <div className="row">
                                  <div className="col-12 checkbox d-flex">
                                    <label className="containerCustom chkFood">
                                      <input
                                        type="checkbox"
                                        value="سایر"
                                        onClick={() => this.selectReason(6)}
                                        name="Reason"
                                      ></input>
                                      <span className="checkmark checkmark-sm"></span>
                                      <div className="title">دلایل دیگر</div>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.state.isReasonOther ? (
                              <div className="w-100 p-0">
                                <textarea
                                  id="ReasonOthers"
                                  name="ReasonOthers"
                                  rows="3"
                                  className="form-control"
                                  placeholder="به صورت شفاف توضیح دهید"
                                  onChange={this.handleReasonOthers}
                                ></textarea>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : null}

                      <div className="col-12 text-center p-0 mt-2">
                        <button
                          className={
                            this.state.isSubmit
                              ? "btn btn-success"
                              : "btn btn-success disabled"
                          }
                          onClick={() => this.toggleSubmit()}
                        >
                          ثبت نظر
                        </button>
                      </div>
                    </>
                  ) : null}
                </>
              )}
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return <React.Fragment></React.Fragment>;
    }
  }
}
export default Register;
